/**
 * LADS REST triple from a canonical function browse path
 * ("DeviceSet/<dev>/FunctionalUnitSet/<fu>/FunctionSet/<fn>").
 *
 * The canonical browsePath is the DATA-request key — also for mounted FUs,
 * where the mount triple (channel.id) is ambiguous and must only be used
 * as a view/cache key.
 */
export function tripleFromBrowsePath(browsePath: string): {
  deviceId: string;
  functionalUnitId: string;
  functionId: string;
} | null {
  const p = browsePath.split("/");
  if (
    p[0] !== "DeviceSet" ||
    !p[1] ||
    p[2] !== "FunctionalUnitSet" ||
    !p[3] ||
    p[4] !== "FunctionSet" ||
    !p[5]
  ) {
    return null;
  }
  return { deviceId: p[1], functionalUnitId: p[3], functionId: p[5] };
}
